import { EventDispatcher, EventStream } from '@cgs/wge';
import { BaseSystem } from './base_system';
import { IconEnumerator } from '../icon_enumerator';
import { ComponentIndex } from '../entities_engine/component_index';
import { EntityCacheHolder } from '../game_components/entity_cache_holder';
import { EntitiesEngine } from '../entities_engine/entities_engine';
import { ComponentNames } from '../entity_components/component_names';
import { Entity } from '../entities_engine/entity';

export class AfterBrakingSystem extends BaseSystem {
  private _enumerator: IconEnumerator;
  private _afterBrakingindex: ComponentIndex;
  private _finalPositionIndex: ComponentIndex;
  private _reelIndex: ComponentIndex;
  private _lineIndex: ComponentIndex;
  private _positionIndex: ComponentIndex;
  private _posInReelIndex: ComponentIndex;
  private _finalEnumerationIndex: ComponentIndex;
  private _enumerationIndex: ComponentIndex;
  private _drawableIndex: ComponentIndex;
  private _previousDrawIndex: ComponentIndex;
  private _entityStopped: EventDispatcher<number[]>;
  get entityStopped(): EventStream<number[]> {
    return this._entityStopped.eventStream;
  }

  constructor(
    engine: EntitiesEngine,
    entityCacheHolder: EntityCacheHolder,
    enumerator: IconEnumerator
  ) {
    super(engine, entityCacheHolder);
    this._enumerator = enumerator;
    this._entityStopped = new EventDispatcher<number[]>();
  }

  getIndexesForFilter(): ComponentIndex[] {
    this._afterBrakingindex = this.engine.getComponentIndex(ComponentNames.AfterBraking);
    this._finalPositionIndex = this.engine.getComponentIndex(ComponentNames.FinalPosition);
    this._reelIndex = this.engine.getComponentIndex(ComponentNames.ReelIndex);
    this._lineIndex = this.engine.getComponentIndex(ComponentNames.LineIndex);
    this._positionIndex = this.engine.getComponentIndex(ComponentNames.Position);
    this._posInReelIndex = this.engine.getComponentIndex(ComponentNames.PositionInReel);
    this._finalEnumerationIndex = this.engine.getComponentIndex(
      ComponentNames.FinalEnumerationIndex
    );
    this._enumerationIndex = this.engine.getComponentIndex(ComponentNames.EnumerationIndex);
    this._drawableIndex = this.engine.getComponentIndex(ComponentNames.DrawableIndex);
    this._previousDrawIndex = this.engine.getComponentIndex('PreviousDrawableIndex');
    return [
      this._afterBrakingindex,
      this._finalPositionIndex,
      this._positionIndex,
      this._reelIndex,
    ];
  }

  processEntity(entity: Entity, _dt: number): void {
    entity.removeComponent(ComponentNames.BrakingInterpolate);
    entity.removeComponent(ComponentNames.Speed);
    entity.removeComponent(ComponentNames.RelocatedFlag);
    entity.set(this._positionIndex, entity.get(this._finalPositionIndex));
    const reel: number = entity.get<number>(this._reelIndex);
    const line: number = entity.get(this._posInReelIndex);
    const enumerationId: number = entity.get(this._finalEnumerationIndex);
    const drawableId: number = this._enumerator.getNext(reel, enumerationId) as number;
    entity.set(this._enumerationIndex, enumerationId);
    if (entity.hasComponent(this._previousDrawIndex)) {
      entity.set(this._previousDrawIndex, drawableId);
    } else {
      entity.set(this._drawableIndex, drawableId);
    }
    entity.set(this._lineIndex, line);
    this.fireStopEvent(reel, line);
    entity.removeComponent(ComponentNames.FinalPosition);
    entity.removeComponent(ComponentNames.PositionInReel);
    entity.removeComponent(ComponentNames.AfterBraking);
    entity.removeComponent(ComponentNames.FinalEnumerationIndex);
    entity.removeComponent(ComponentNames.CalculationReadyFlag);
    entity.removeComponent(ComponentNames.SingleSpinningIndex);
  }

  fireStopEvent(reel: number, line: number): void {
    this._entityStopped.dispatchEvent([reel, line]);
  }
}
